var LineScheduleBuilder = /** @class */ (function () {
    function LineScheduleBuilder() {
        this.schedule = {
            downTimes: [],
            timeZone: 'UTC',
        };
    }
    LineScheduleBuilder.prototype.withScheduleId = function (scheduleId) {
        this.schedule.scheduleId = scheduleId;
        return this;
    };
    LineScheduleBuilder.prototype.withUseSchedule = function (useSchedule) {
        this.schedule.useSchedule = useSchedule;
        return this;
    };
    LineScheduleBuilder.prototype.withDownTimes = function (downTimes) {
        this.schedule.downTimes = downTimes;
        return this;
    };
    LineScheduleBuilder.prototype.withTimeZone = function (timeZone) {
        this.schedule.timeZone = timeZone;
        return this;
    };
    LineScheduleBuilder.prototype.withOffHoursSmsMessage = function (offHoursSmsMessage) {
        this.schedule.offHoursSmsMessage = offHoursSmsMessage;
        return this;
    };
    LineScheduleBuilder.prototype.build = function () {
        return this.schedule;
    };
    return LineScheduleBuilder;
}());
export { LineScheduleBuilder };
//# sourceMappingURL=line-schedule.builder.js.map